import { GET_CUSTOMERS } from './actions';

const initialState = {
  customers: [],
};

export default function Reducer(state = initialState, action) {
  const { type, data } = action;
  switch (type) {
    case GET_CUSTOMERS:
      return {
        ...state,
        customers: data,
      };
    default:
      return state;
  }
}
